import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Nav } from "@/components/Nav";
import { ProtocolView } from "@/components/ProtocolView";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";

export default function JobPage() {
  const { id } = useParams();
  const { t } = useLang();
  const [job, setJob] = useState(null);

  useEffect(() => {
    let active = true;
    const tick = () => api.get(`/ai/jobs/${id}`).then((r) => active && setJob(r.data)).catch(() => {});
    tick();
    const iv = setInterval(() => {
      if (job && ["done", "error"].includes(job.status)) return;
      tick();
    }, 3000);
    return () => {
      active = false;
      clearInterval(iv);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, job?.status]);

  return (
    <div className="min-h-screen" data-testid="job-page">
      <Nav />
      <main className="mx-auto max-w-5xl px-6 py-12">
        <Link to="/dashboard" className="mb-8 inline-flex items-center gap-2 text-sm text-vox-dim hover:text-vox-text"><ArrowLeft size={14} /> {t("nav.dashboard")}</Link>
        {job ? <ProtocolView job={job} onChanged={(patch) => setJob((j) => ({ ...j, ...patch }))} /> : <div className="flex items-center gap-2 text-sm text-vox-dim"><Loader2 size={14} className="animate-spin" />{t("common.loading")}</div>}
      </main>
    </div>
  );
}
